import gql from 'graphql-tag';

import getClient from 'src/modules/ApiClient/hirerGraph/apiClient';
import type { AccountSelectionOptions } from 'src/modules/ApiClient/types';

const accountParts = gql`
  fragment accountParts on AdvertiserAccountOption {
    advertiserId
    displayText
    seekId
  }
`;

export const query = gql`
  ${accountParts}
  query GetAccountSelection {
    accountSelection {
      accounts {
        ...accountParts
        childAccounts {
          ...accountParts
        }
      }
      defaultAccount {
        ...accountParts
      }
    }
  }
`;

export type GetAccountSelection = () => Promise<AccountSelectionOptions>;

const getAccountSelection: GetAccountSelection = async () => {
  const graphqlClient = getClient();
  const result = await graphqlClient.query<{
    accountSelection: AccountSelectionOptions;
  }>({
    query,
  });

  return result.data.accountSelection;
};

export default getAccountSelection;
